module.exports = __webpack_public_path__ + "b239d1bb6bcdc86c1fcd7087b352bbf5.pdf";